import { useEffect } from 'react'
import { useDocumentManagerCapability } from '@embedpdf/plugin-document-manager/react'
import { getDocument, getPreference } from '../../services/indexeddb-service'
import { OcrService } from '../../services/ocr/ocr-service'

let didRestore = false

export function DocumentRestorer() {
  const { provides: docManager } = useDocumentManagerCapability()

  useEffect(() => {
    if (!docManager || didRestore) return
    const openDocs = docManager.getOpenDocuments?.()
    if (openDocs && openDocs.length > 0) return
    didRestore = true

    getPreference<string[]>('open-documents').then(async (openList) => {
      if (!openList || openList.length === 0) return
      const currentDocKey = 'current-document'
      const currentDoc = await getDocument(currentDocKey)
      for (const docId of openList) {
        const isLastActive = currentDoc?.name === docId
        if (isLastActive) continue
        const saved = await getDocument(docId)
        if (saved?.buffer) {
          try {
            const task = docManager.openDocumentBuffer({
              name: saved.name,
              buffer: saved.buffer.slice(0),
              autoActivate: false,
            })
            await task.toPromise()
          } catch {}
        }
      }
      const lastActiveDoc = currentDoc || await getDocument(openList[openList.length - 1]!)
      if (lastActiveDoc?.buffer) {
        OcrService.setDocumentName(lastActiveDoc.name)
        const openDocsNow = docManager.getOpenDocuments?.()
        const shouldActivate = !openDocsNow || openDocsNow.length === 0
        try {
          const task = docManager.openDocumentBuffer({
            name: lastActiveDoc.name,
            buffer: lastActiveDoc.buffer.slice(0),
            autoActivate: shouldActivate,
          })
          await task.toPromise()
        } catch {}
      }
    })
  }, [docManager])

  return null
}
